export default __webpack_public_path__ + "static/media/project4.70cbb005.png";